import { useRouter } from 'next/navigation';
import { useState, useCallback, useEffect } from 'react';

const currencyRates = {
  MAD: { AED: 0.27 },
  AED: { MAD: 3.70 },
};

const currencies = [
  { code: "MAD", symbol: "DH", name: "Moroccan Dirham" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
];

const useCurrency = () => {
  const router = useRouter();
  
  // Only access window on the client-side
  const [selectedCurrency, setSelectedCurrency] = useState(() => {
    if (typeof window !== 'undefined') {
      const savedCurrency = window.localStorage.getItem('selectedCurrency');
      return savedCurrency 
        ? currencies.find(c => c.code === savedCurrency) || currencies[0]
        : currencies[0];
    }
    return currencies[0];
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('selectedCurrency', selectedCurrency.code);
    }
  }, [selectedCurrency]);

  const convertPrice = useCallback((price) => {
    const baseCurrency = 'MAD'; // Default currency for your system
    const toCurrency = selectedCurrency.code;
    
    if (baseCurrency === toCurrency) return price;
    const rate = currencyRates[baseCurrency]?.[toCurrency];
    
    if (!rate) {
      console.warn(`Exchange rate not found: ${baseCurrency} to ${toCurrency}`);
      return (price).toFixed(2);
    }
    
    return (price * rate).toFixed(2);
  }, [selectedCurrency]);

  const changeCurrency = useCallback((currencyCode) => {
    const newCurrency = currencies.find(currency => currency.code === currencyCode);
    if (newCurrency) {
      setSelectedCurrency(newCurrency);
      window.location.reload()
    } else {
      console.warn("Currency not found:", currencyCode);
    }
  }, [router]);

  return {
    selectedCurrency,
    changeCurrency,
    currencies,
    convertPrice,
  };
};

export default useCurrency;
